import { Radio as RadioMantine } from '@mantine/core'
import React, { useState } from 'react'

import { PortadorasService } from '../../../../services/http/portadoras.service'
import { useGlobal } from '../../../../stores/useGlobal'
import MensagemInformacao from '../../../componentesModais/mensagens/mensagemInformacao'
import Botao from '../../../Mantine/Botao'
import Divider from '../../../Mantine/Divider'
import Modal from '../../../Mantine/Modal'
import Radio from '../../../Mantine/Radio'

import * as S from './styles'

const OPCOES = [
  { value: '24', label: 'Últimas 24h' },
  { value: '2', label: 'Últimos 2 dias' },
  { value: '3', label: 'Últimos 3 dias' },
  { value: '4', label: 'Últimos 4 dias' },
  { value: '5', label: 'Últimos 5 dias' },
  { value: '6', label: 'Últimos 6 dias' },
  { value: '7', label: 'Últimos 7 dias' }
]

export default function HistoricoConsumo({ opened, selecionados }) {
  const [selected, setSelected] = useState()
  const [alert, setAlert] = useState(false)

  const {
    filtros,
    busca,
    exportarRelatorio,
    setExportarRelatorio,
    setMostrarNotificacao,
    setIsLoadingGlobal
  } = useGlobal()

  const { createConsumptionReport } = PortadorasService

  const handleChange = (value) => setSelected(value)

  const handleClose = () => {
    setSelected()
    setExportarRelatorio({})
  }

  const handleConfirm = async () => {
    const payload = {
      tipo_arquivo: exportarRelatorio.tipo,
      arrayCdCarrier: selecionados.map((item) => item.id)
    }

    if (!filtros.vazio) {
      payload.filter = filtros
    }
    if (busca) {
      payload.fetch = busca
    }

    payload.hours = selected === '24' ? 24 : Number(selected) * 24
    setIsLoadingGlobal(true)
    await createConsumptionReport(payload)
      .then(() => setAlert(true))
      .catch(() => {
        setMostrarNotificacao({
          show: true,
          type: 'error',
          autoHide: 5000,
          title: 'Falha ao gerar relatório',
          message:
            'Não foi possível gerar o relatório, tente novamente mais tarde.'
        })
      })
      .finally(() => setIsLoadingGlobal(false))
  }

  if (alert) {
    return (
      <MensagemInformacao
        handleMensagemInformacao={() => {
          handleClose()
          setAlert(false)
        }}
        mensagemTitulo="Sucesso"
        mensagemParagrafo1="Esse processo levará alguns minutos, você poderá fazer o download do seu arquivo na tela de relatórios assim que o link do mesmo estiver disponível."
        mensagemBotao="Fechar"
      />
    )
  }

  return (
    <Modal
      width="330px"
      withCloseButton={false}
      disableElipse
      titulo="Selecione o período"
      opened={opened}
      close={handleClose}
      showActionsModal={false}
    >
      <S.SubTitle>
        Selecione o período que deseja exportar seu relatório:
      </S.SubTitle>
      <RadioMantine.Group
        name="PERIODO"
        value={selected}
        onChange={handleChange}
      >
        <S.CheckboxAndRadioWrapper>
          {OPCOES?.map((opcao) => (
            <Radio key={opcao.value} value={opcao.value} label={opcao.label} />
          ))}
        </S.CheckboxAndRadioWrapper>
      </RadioMantine.Group>
      <Divider />
      <S.BotoesWrapper>
        <Botao label="Cancelar" variant="outline" onClick={handleClose} />
        <Botao
          disabled={!selected}
          label="Confirmar"
          variant="primary"
          onClick={handleConfirm}
        />
      </S.BotoesWrapper>
    </Modal>
  )
}
